import { useEffect, useRef, useState } from "react";
import QRCode from "qrcode";

export default function QrCard() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [url, setUrl] = useState<string | null>(null);
  const [warning, setWarning] = useState<string | null>(null);

  useEffect(() => {
    fetch("/api/admin/entry-url")
      .then((r) => r.json())
      .then((body: { url: string | null; warning: string | null }) => {
        setUrl(body.url);
        setWarning(body.warning);
      });
  }, []);

  useEffect(() => {
    if (url && canvasRef.current) {
      QRCode.toCanvas(canvasRef.current, url, { width: 320, margin: 2 }).catch(() => {});
    }
  }, [url]);

  function downloadPng() {
    if (!canvasRef.current) return;
    const link = document.createElement("a");
    link.download = "send-michael-post-qr.png";
    link.href = canvasRef.current.toDataURL("image/png");
    link.click();
  }

  async function downloadSvg() {
    if (!url) return;
    const svg = await QRCode.toString(url, { type: "svg", margin: 2, width: 320 });
    const blob = new Blob([svg], { type: "image/svg+xml" });
    const link = document.createElement("a");
    link.download = "send-michael-post-qr.svg";
    link.href = URL.createObjectURL(blob);
    link.click();
  }

  return (
    <div className="stack">
      <h2>QR code</h2>
      <p className="field-help">
        This QR encodes only the app's URL — never an address, BFPO number, or ship name — so the destination can change
        without ever reprinting it.
      </p>

      {warning && (
        <div className="banner banner-warn">
          <span>{warning}</span>
        </div>
      )}

      {url && (
        <div className="card stack" style={{ alignItems: "center", textAlign: "center" }}>
          <canvas ref={canvasRef} aria-label="Send Michael Post entry QR code" />
          <code style={{ wordBreak: "break-all" }}>{url}</code>
          <div style={{ display: "flex", gap: "var(--space-2)" }}>
            <button className="btn btn-secondary" style={{ width: "auto" }} onClick={downloadPng}>
              Download PNG
            </button>
            <button className="btn btn-secondary" style={{ width: "auto" }} onClick={downloadSvg}>
              Download SVG
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
